import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { RobotRulesService, EditMode, RateEventType } from "../../robot-rules.service";
import _ from "lodash";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { TranslateService } from "@root/shared/service/translate.service";
import { padStart } from "@root/util/date";
import { Observable, of } from "rxjs";

@Component({
  selector: "host-rate-guest-rules",
  templateUrl: "./rate-guest.component.html",
  styleUrls: ["./rate-guest.component.scss"],
})
export class RateGuestComponent implements OnInit {
  @ViewChild("textarea", { static: true }) textarea;
  readonly EventType: typeof RateEventType = RateEventType;
  private readonly EventMap: Record<RateEventType, Array<any>> = {
    [RateEventType.Checkout]: [
      { label: this.t.syncGet("robot.rule.check_event.after_checkout"), value: "after_checkout", type: 1 },
    ],
  };
  private readonly defaultScopeChannels = [-1];
  private readonly defaultScopeAccounts = [-1];
  private readonly defaultScopeHouses = [-1];
  @Input() editMode: EditMode = EditMode.Create;
  @Input() event: RateEventType = RateEventType.Checkout;
  @Input() id;
  @Input() subevent = "after_checkout"; // 暂时只有一个，且不可改
  @Input() listOfChannelOption = [];
  // @Input() listOfHouseOption = [];
  @Input() listOfDynContentOption = [];
  readonly listOfDayOption = _.range(0, 61).map((i) => ({
    label: this.t.t(`automation.message_rule.option.day.${i > 1 ? "plural" : "single"}`, { number: i }),
    value: i,
  }));
  readonly listOfTimeOption = _.range(0, 24).map((hour) => ({ label: `${padStart(hour, 2)}:00`, value: hour * 60 }));
  listOfChannelAccountOption = [];
  detail;
  // selectHouseType: "none" | "house" | "room_type" | "group" = "none";
  scopeChannels = null;
  scopeAccounts = null;
  scopeHouses = {
    type: "none",
    value: this.defaultScopeHouses,
  };
  // actionNodeMinute = 13 * 60; // 默认13点
  actionTextType = 0; // 文本类型 0-文本 1-快捷回复
  actionTextContent = "";
  actionQuickMsgId = null; // 快捷消息id，textType = 1 时有效
  // initialChannels = [];
  // initialAccounts = [];
  // initialHouses = [];
  // initialGroupOrType = null;
  dynContent;
  nights = {
    start: 1,
    end: -1,
  };

  eventDay = 1; // 默认1天
  eventTime = 13 * 60; // 默认13点

  /** 理论可以不需要这个getter，因为只有一个选项，且不可更改，为了和其他页面逻辑统一，采用统一的处理方式 */
  // get subeventOptions () {
  //   return this.EventMap[this.event]
  // }
  constructor(
    private http: RobotRulesService,
    private messageService: NzMessageService,
    private modal: NzModalService,
    private modalRef: NzModalRef,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    console.log("rate guest init");

    if (this.editMode === EditMode.Update || this.editMode === EditMode.Copy) {
      this.fetchRateRuleDetail();
    } else {
      this.initSelectOptions();
      // this.fetchChannelAccounts();
    }
  }

  private initSelectOptions() {
    this.fetchChannelAccounts();
  }

  private fetchChannelAccounts() {
    // const channels = this.scopeChannels.filter((c) => c !== -1);
    const params = {
      from: "comment",
    };
    if (this.scopeChannels) {
      Object.assign(params, { thirdparty_types: JSON.stringify(this.scopeChannels) });
    }
    this.http.fetchChannelAccounts(params).subscribe((res) => {
      console.log("res: ", res);
      const list = _.get(res, "data.list");
      this.listOfChannelAccountOption = list.map((account) => ({
        ...account,
        label: account.username,
        value: account.id,
      }));
    });
  }
  fetchRateRuleDetail() {
    this.http.fetchRateRuleDetail({ id: this.id }).subscribe((res) => {
      console.log("fffres: ", res);
      const record = _.get(res, "data.record") || {};
      this.detail = record;
      const { id, action, event, scope, nights_start, nights_end } = record;
      this.id = id;
      this.convertFromActionParams(action);
      this.convertFromScopeParams(scope);

      this.nights = {
        start: nights_start || 1,
        end: nights_end || -1,
      };

      // this.fetchChannelAccounts();
      this.initSelectOptions();
    });
  }
  requestSaveRateRobotRules(extend = false) {
    const status = 1;
    const action = this.convertToActionParams();
    const scope = this.convertToScopeParams();

    const params = {
      status,
      event,
      action,
      scope,

      /** 4.4后新加，暂时处理 */
      nights_start: this.nights.start,
      nights_end: this.nights.end,

      extend_exist_reservation: extend ? 1 : 0,
    };

    if (this.editMode === EditMode.Update) {
      /** 新建和复制都不传id */
      _.assign(params, { id: this.id });
    }

    return this.http.updateRateRobotRules(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.messageService.success(this.t.t("word.success"));

        this.close();
      }
    });
  }

  onSave() {
    let warning$ = of<"ok" | "cancel">("cancel");
    if (this.editMode === EditMode.Update && this.actionTextContent !== this.detail.action?.text_content) {
      warning$ = this.applyModifyWarning();
    }
    warning$.subscribe((status) => {
      this.requestSaveRateRobotRules(status === "ok");
    });
  }

  onCancel() {
    this.close();
  }

  //#region Apply Reservation

  private applyModifyWarning(): Observable<"ok" | "cancel"> {
    return new Observable((observer) => {
      const modal = this.modal.confirm({
        nzTitle: this.t.t("auto-apply-to-resvs_modal_title"),
        nzContent: this.t.t("auto-apply-to-resvs_modal_content"),
        nzWidth: 540,
        nzCancelText: this.t.t("word.no"),
        nzOkText: this.t.t("word.yes"),
        nzOnOk: () => {
          observer.next("ok");
        },
        nzOnCancel: () => {
          observer.next("cancel");
        },
      });

      modal.afterClose.subscribe(() => observer.complete());
    });
  }

  // private requestApplyToResvs() {
  //   const params = {};
  //   if (this.editMode === EditMode.Update) {
  //     Object.assign(params, { id: this.id });
  //   }

  //   this.http.requestApplyToResvsForComment(params).subscribe();
  // }

  //#endregion

  // onSelectHouseTypeChange(type) {
  //   console.log("type: ", type);
  //   // if (type === "none") {
  //   //   this.scopeHouses = [{ id: -1, house_title: "" }];
  //   // }
  // }

  // onSelectHousesByHouse(ids = []) {
  //   console.log("by house: ", ids);
  //   // this.scopeHouses = ids.map((id) => ({ id, house_title: "" }));
  // }

  // onSelectHousesByGroup(data) {
  //   const { ids, type } = data;
  //   this.selectHouseSubType = type;
  //   this.scopeHouses = ids.map((id) => ({ id, house_title: "" }));
  //   console.log("by group: ", data);
  // }

  onSelectChannels(channels = []) {
    console.log("channels: ", channels);
    // this.scopeChannels = channels.map((channel) => ({
    //   thirdparty_type: channel,
    //   name: "",
    // }));

    this.fetchChannelAccounts();
  }

  onSelectAccounts(accounts) {
    console.log("accounts: ", accounts);
    // this.scopeAccounts = accounts.map((account) => ({
    //   id: account,
    //   name: "",
    // }));
  }

  onSelectQuickMsgOfAction(data = { id: null, content: "" }) {
    console.log("onSelectQuickMsgOfAction", data);
    const { id, content } = data;
    this.actionQuickMsgId = id;
    this.actionTextContent = content;
  }

  onSelectDynContent(content) {
    const value = this.actionTextContent;
    const pos = this.textarea.nativeElement.selectionStart;

    this.actionTextContent = value.slice(0, pos) + `{{${content}}}` + value.slice(pos);
  }

  private convertToActionParams() {
    const action = {
      action_type: this.actionQuickMsgId === null ? 0 : 1,
      text_content: this.actionTextContent,
      quick_message_id: this.actionQuickMsgId,
      node_minute: this.eventDay * 24 * 60 + this.eventTime,
    };
    return action;
  }

  private convertToScopeParams() {
    const scope = {
      thirdparty: this.getOrDefault(this.scopeChannels, this.defaultScopeChannels),
      account: this.getOrDefault(this.scopeAccounts, this.defaultScopeAccounts),
    };

    const { type, value } = this.scopeHouses;
    const scopeHouses = this.getOrDefault(value, this.defaultScopeHouses);

    if (type === "none") {
      Object.assign(scope, { property_any: [-1] });
    } else if (type === "house") {
      Object.assign(scope, { house: scopeHouses });
    } else if (type === "group") {
      Object.assign(scope, { group: scopeHouses });
    } else {
      Object.assign(scope, { room_type: scopeHouses });
    }
    return scope;
  }

  private convertFromActionParams(params) {
    this.actionQuickMsgId = params.quick_message_id === -1 ? null : params.quick_message_id;
    this.actionTextContent = params.text_content;
    // this.actionNodeMinute = params.node_minute;
    this.eventDay = Math.floor(params.node_minute / (24 * 60));
    this.eventTime = params.node_minute % (24 * 60);
  }

  private convertFromScopeParams(params) {
    if (params.account?.[0] === -1) {
      this.scopeAccounts = null;
    } else {
      this.scopeAccounts = params.account;
    }

    if (params.thirdparty?.[0] === -1) {
      this.scopeChannels = null;
    } else {
      this.scopeChannels = params.thirdparty;
    }

    console.log("scope channels: ", this.scopeChannels);

    if (params.group) {
      this.scopeHouses = {
        type: "group",
        value: params.group,
      };
    } else if (params.room_type) {
      this.scopeHouses = {
        type: "room_type",
        value: params.room_type,
      };
    } else {
      if (params.house?.[0] === -1 || params.property_any?.[0] === -1) {
        this.scopeHouses = {
          type: "none",
          value: [-1],
        };
      } else {
        this.scopeHouses = {
          type: "house",
          value: params.house,
        };
      }
    }

    // this.initialChannels = this.scopeChannels.filter((c) => c !== -1);
    // this.initialAccounts = this.scopeAccounts.filter((id) => id !== -1);
    // console.log("initialchannels: ", this.initialChannels);
  }

  private getOrDefault(value: any[], defaults) {
    if (_.isEmpty(value)) {
      return defaults;
    }
    return value;
  }

  private close() {
    this.modalRef.close();
  }
}
